module.exports = __webpack_public_path__ + "img/mga.bd98b1bb.png";